import React from "react";

interface IconProps extends React.SVGProps<SVGSVGElement> {
  iconName: string;
}

const Icon: React.FC<IconProps> = ({ iconName, className, ...props }) => {
  const finalClassName = `icon icon-${iconName} ${className || ""}`.trim();

  return (
    <svg className={finalClassName} aria-hidden="true" role="img" {...props}>
      <use xlinkHref={`#icon-${iconName}`} />
    </svg>
  );
};

export default Icon;
